var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgVerifiedUser = function SvgVerifiedUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.542 5.3l-1.486-.853-.856-1.488H9.484L8 2.1l-1.486.859H4.8l-.858 1.488-1.485.853v1.716L1.6 8.5l.857 1.486V11.7l1.486.858.857 1.489h1.715L8 14.9l1.484-.853H11.2l.857-1.486 1.485-.861V9.986L14.4 8.5l-.858-1.484V5.3zm-6.12 5.82a.623.623 0 01-.866 0L4.684 9.25a.6.6 0 010-.85l.497-.497a.6.6 0 01.85 0l.96.96L9.97 5.88a.601.601 0 01.85 0l.497.498a.601.601 0 010 .85L7.422 11.12z",
    fill: "#439AFF"
  })));
};
export default SvgVerifiedUser;